import React from "react";

import { multipleChoiceConfirmWrapper } from "../../../../../../../components/Modals/MultipleChoiceConfirmWrapper";
import TrashIcon from "../../../../../../../resources/route-builder/trash.svg";
import type { ProposedRoute } from "../../../../../../../types/routeBuilder";
import { useRouteBuilder } from "../../../context/RouteBuilderContext";

export function AddRouteButton({ className = "" }: { className?: string }) {
  const { addRoute } = useRouteBuilder();
  return (
    <button
      type="button"
      data-testid="add-route-button"
      className={`text-xs font-medium text-slate-500 underline hover:text-snow-primary ${className}`}
      onClick={(event) => {
        event.stopPropagation();
        addRoute();
      }}
    >
      + Add Route
    </button>
  );
}

export function RemoveRouteButton({ route }: { route: ProposedRoute }) {
  const { removeRoute } = useRouteBuilder();
  return (
    <button
      type="button"
      data-testid={`remove-route-${route.id}`}
      className="shrink-0 rounded p-0.5 text-slate-400 hover:bg-rose-50 hover:text-rose-600"
      aria-label={`Remove ${route.name}`}
      title="Remove route"
      onClick={async (event) => {
        event.stopPropagation();
        const confirmed = await multipleChoiceConfirmWrapper(
          `Delete ${route.name}?`,
          {
            description: `Its ${route.stops.length} ${route.stops.length === 1 ? "property will" : "properties will"} move to Unassigned.`,
            confirmLabel: "Delete",
          },
        );
        if (confirmed) removeRoute(route.id);
      }}
    >
      <img src={TrashIcon} alt="" className="h-4 w-4" aria-hidden />
    </button>
  );
}
